module.exports = __webpack_public_path__ + "static/media/RobotoMono-Medium.8ad82b1d.ttf";